import type { StorageItemDto, StoragePageDto } from './dto';
import type { StorageItem, StoragePage } from './types';

function str(value: string | null | undefined): string | null {
    if (typeof value !== 'string') return null;
    const trimmed = value.trim();
    if (trimmed === '' || trimmed === 'None') return null;
    return trimmed;
}

function toDate(value: string | null | undefined): Date | null {
    const raw = str(value);
    if (raw === null) return null;
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function toStorageItem(dto: StorageItemDto): StorageItem {
    return {
        id: dto.id,
        title: str(dto.user?.full_name) ?? str(dto.organization?.name) ?? '—',
        operationId: str(dto.operation_identifier) ?? '—',
        projectId: str(dto.project_id),
        projectName: str(dto.project_name) ?? '—',
        projectStorage: dto.project_storage ?? 0,
        totalStorage: dto.total_storage ?? 0,
        uploadedAt: toDate(dto.upload_date),
    };
}

export function toStoragePage(dto: StoragePageDto): StoragePage {
    return {
        items: Array.isArray(dto?.data) ? dto.data.map(toStorageItem) : [],
        total: dto?.count ?? 0,
        pages: dto?.pages ?? 1,
        pageNum: dto?.page_num ?? 1,
    };
}